import { getNumberItemFromStorage } from "@/scripts/Common/componentStorage";
import { ISSUER_ID_STORAGE_KEY } from "../constants";
import { fetchIssuer, fetchIssuers } from "./requests";

const fetchFirstIssuer = async () => {
  // no customer found in storage or customer does not exist anymore, load first customer from list of all customers
  const { response, error } = await fetchIssuers({ pageSize: 1 });

  return { error, response: response?.[0] };
}

/**
 * Tries to load customer from local storage if available. If not it will load the first customer from the list of customers
 *
 * @returns {Promise<{ error?: any, response?: Issuer }>} - Returns issuer from storage or first issuer from list of all issuers
 */
const loadIssuerFromStorageOrFirst = async () => {
  const issuerId = getNumberItemFromStorage(ISSUER_ID_STORAGE_KEY);

  const { response, error } = await fetchIssuer(issuerId);

  return error ? fetchFirstIssuer() : { error, response };
}

export {
  loadIssuerFromStorageOrFirst
}
